import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { platformSelect } from '@bubble-ui/util-platform';
import { isLollipop } from '@bubble-ui/particle-design-versions';
var getCommonStyleSheet = specificButtonStyles => _ref => {
  var _designContext$get;
  var {
    designVersion,
    designContext,
    disabled,
    hasMinWidth,
    hovered,
    icon,
    isSmall,
    isMedium,
    klarnaLogo,
    loading,
    pressed,
    isIconLeftAlign
  } = _ref;
  var {
    variant,
    backgroundColorToken,
    borderColorToken,
    focusBorderColorToken,
    textColorToken,
    loaderInverted
  } = specificButtonStyles({
    designVersion
  });
  var buttonSize = isSmall ? 'small' : isMedium ? 'medium' : 'default';

  // ActionIcons SVGs are 12px but our components are 20px
  var paddingAroundActionIcon = 4;
  var baseButtonCornerRadius = designContext.get('base-button/corner-radius', {
    buttonSize
  }).pixelValue;
  var baseButtonBorderRadius = isLollipop(designVersion) && !isSmall && !isMedium ? 0 : baseButtonCornerRadius;
  var baseButtonKeyboardFocusBorderRadius = designContext.get('base-button/keyboard-focus-corner-radius', {
    buttonSize
  }).pixelValue;
  var colorTokenArgs = {
    interactiveState: disabled ? 'disabled' : loading ? 'default' : pressed ? 'pressed' : hovered ? 'hovered' : 'default',
    variant
  };
  var finalBackgroundColorToken = variant ? 'base-button/background-color' : backgroundColorToken;
  var backgroundColor = finalBackgroundColorToken ? designContext.get(finalBackgroundColorToken, colorTokenArgs).toString() : undefined;
  var finalBorderColorToken = variant ? 'base-button/border-color' : borderColorToken;
  var finalBorderColor = finalBorderColorToken ? (_designContext$get = designContext.get(finalBorderColorToken, colorTokenArgs)) === null || _designContext$get === void 0 ? void 0 : _designContext$get.toString() : undefined;
  var finalFocusBorderColorToken = variant ? 'base-button/focus-border-color' : focusBorderColorToken;
  var focusBorderColor = finalFocusBorderColorToken ? designContext.get(finalFocusBorderColorToken, colorTokenArgs).toString() : undefined;
  var finalTextColorToken = variant ? 'base-button/text-color' : textColorToken;
  var textColor = finalTextColorToken ? designContext.get(finalTextColorToken, colorTokenArgs).toString() : undefined;
  var borderWidth = finalBorderColor ? 1 : 0;
  var height = designContext.get('base-button/height', {
    buttonSize
  }).pixelValue;
  var extraPaddingRightForKlarnaLogo = klarnaLogo ? 31 : 0;
  return {
    buttonStyle: {
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      border: 'none',
      cursor: disabled || loading ? 'auto' : 'pointer',
      outline: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      marginBottom: 0,
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString()
    },
    viewStyle: _objectSpread(_objectSpread({
      backgroundColor,
      borderColor: finalBorderColor,
      borderStyle: 'solid',
      borderWidth,
      borderRadius: baseButtonBorderRadius,
      height
    }, hasMinWidth && {
      minWidth: 150 - borderWidth
    }), {}, {
      justifyContent: 'center',
      flexDirection: 'row',
      paddingLeft: (isSmall && isIconLeftAlign && icon ? height / 2 - paddingAroundActionIcon : height / 2) + 1 - borderWidth,
      paddingRight: (isSmall && !isIconLeftAlign && icon ? height / 2 - paddingAroundActionIcon : height / 2) + 1 + extraPaddingRightForKlarnaLogo - borderWidth,
      alignItems: 'center',
      position: 'relative',
      transition: 'background-color .2s ease, border-color .2s ease, color .2s ease'
    }),
    keyboardFocusStyle: {
      borderRadius: baseButtonKeyboardFocusBorderRadius,
      bottom: -5,
      left: -5,
      position: 'absolute',
      right: -5,
      top: -5,
      transition: 'border-color .2s ease',
      zIndex: 1,
      borderWidth: 2,
      borderColor: focusBorderColor
    },
    iconWrapperStyle: _objectSpread({}, isIconLeftAlign ? {
      paddingRight: isSmall ? 10 - paddingAroundActionIcon : 10
    } : {
      paddingLeft: isSmall ? 10 - paddingAroundActionIcon : 10
    }),
    klarnaLogoWrapperStyle: {
      marginLeft: -16,
      paddingRight: 20
    },
    iconStyle: variant ? {
      colorToken: 'base-button/text-color',
      colorTokenArgs
    } : textColorToken ? {
      colorToken: textColorToken,
      colorTokenArgs
    } : {},
    klarnaLogoProps: {
      UNSAFE_pathStyle: {
        fill: textColor
      }
    },
    loaderProps: _objectSpread(_objectSpread({}, finalTextColorToken ? {
      UNSAFE_colorToken: finalTextColorToken,
      UNSAFE_colorTokenArgs: colorTokenArgs
    } : {
      inverted: loaderInverted
    }), {}, {
      small: isSmall
    }),
    loadingWrapper: {
      alignSelf: 'center',
      position: 'absolute'
    },
    textWrapperStyle: _objectSpread({}, platformSelect({
      android: {
        marginTop: isSmall ? 2 : 1
      },
      ios: {
        marginTop: isSmall ? 2 : 2.5
      },
      default: {
        marginTop: isSmall ? 0 : -1
      }
    })),
    textStyle: _objectSpread(_objectSpread({
      color: textColor
    }, designContext.get('base-button/text-style', {
      buttonSize
    }).styles()), {}, {
      opacity: loading ? 0 : 1,
      transition: 'color .2s ease',
      visibility: loading ? 'hidden' : 'visible'
    })
  };
};
export default getCommonStyleSheet;
//# sourceMappingURL=commonStyles.js.map